<template>
  <div>
    <div class="page-head">
      <div>
        <h2>服务选项</h2>
        <p>统一维护高端定制、线路定制和服务下单使用的偏好及酒店等级。</p>
      </div>
      <el-button type="primary" @click="openCreate">新增选项</el-button>
    </div>

    <el-card shadow="never">
      <el-form :inline="true" :model="filters" size="small">
        <el-form-item label="关键词"><el-input v-model="filters.keyword" placeholder="稳定键/名称" clearable /></el-form-item>
        <el-form-item label="选项类型">
          <el-select v-model="filters.option_type" placeholder="全部" clearable>
            <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="filters.status" placeholder="全部" clearable>
            <el-option label="启用" value="active" />
            <el-option label="停用" value="inactive" />
          </el-select>
        </el-form-item>
        <el-form-item><el-button type="primary" @click="fetchList">查询</el-button><el-button @click="reset">重置</el-button></el-form-item>
      </el-form>

      <paged-table :rows="rows" :loading="loading" :page="page" :page-size="pageSize" :total="total" @page-change="page = $event; fetchList()" @size-change="pageSize = $event; page = 1; fetchList()">
        <el-table-column prop="option_key" label="稳定键" min-width="170" />
        <el-table-column prop="name" label="显示名称" min-width="170" />
        <el-table-column label="类型" width="140"><template slot-scope="{ row }">{{ typeText(row.option_type) }}</template></el-table-column>
        <el-table-column prop="status" label="状态" width="150">
          <template slot-scope="{ row }">
            <el-switch :value="row.status === 'active'" active-text="启用" inactive-text="停用" @change="changeStatus(row, $event ? 'active' : 'inactive')" />
          </template>
        </el-table-column>
        <el-table-column prop="sort_order" label="排序" width="130">
          <template slot-scope="{ row }"><sort-input :value="Number(row.sort_order || 0)" @change="changeSort(row, $event)" /></template>
        </el-table-column>
        <el-table-column label="操作" width="100" fixed="right"><template slot-scope="{ row }"><el-button type="text" @click="openEdit(row)">编辑</el-button></template></el-table-column>
      </paged-table>
    </el-card>

    <el-dialog :title="drawerMode === 'create' ? '新增服务选项' : '编辑服务选项'" :visible.sync="drawerVisible" width="520px" destroy-on-close>
      <el-form ref="form" :model="form" :rules="rules" label-width="110px">
        <el-form-item label="稳定键" prop="option_key">
          <el-input v-model="form.option_key" :disabled="drawerMode === 'edit'" placeholder="例如 route_dining" />
          <div class="field-help">创建后不可修改；小程序以此选择图标和业务含义。</div>
        </el-form-item>
        <el-form-item label="显示名称" prop="name"><el-input v-model="form.name" /></el-form-item>
        <el-form-item label="选项类型" prop="option_type">
          <el-select v-model="form.option_type">
            <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="初始排序"><el-input-number v-model="form.sort_order" :min="0" :max="999999" /></el-form-item>
      </el-form>
      <div class="drawer-footer">
        <el-button @click="drawerVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="save">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PagedTable from "../components/PagedTable.vue";
import SortInput from "../components/SortInput.vue";
import { changeResourceStatus, createResource, listResource, updateResource } from "../api/resources";

export default {
  name: "ServiceNeedOptionsManage",
  components: { PagedTable, SortInput },
  data() {
    return {
      loading: false,
      saving: false,
      drawerVisible: false,
      drawerMode: "create",
      rows: [],
      total: 0,
      page: 1,
      pageSize: 20,
      filters: { keyword: "", option_type: "", status: "" },
      form: this.emptyForm(),
      typeOptions: [
        { label: "服务偏好", value: "service_need" },
        { label: "线路服务", value: "route_service" },
        { label: "酒店等级", value: "hotel_level" }
      ],
      rules: {
        option_key: [
          { required: true, message: "请填写稳定键", trigger: "blur" },
          { pattern: /^[a-z][a-z0-9_]{1,79}$/, message: "仅支持2到80位小写字母、数字和下划线", trigger: "blur" }
        ],
        name: [{ required: true, message: "请填写显示名称", trigger: "blur" }],
        option_type: [{ required: true, message: "请选择类型", trigger: "change" }]
      }
    };
  },
  mounted() {
    this.fetchList();
  },
  methods: {
    emptyForm() {
      return { option_key: "", name: "", option_type: "service_need", status: "active", sort_order: 0 };
    },
    typeText(value) {
      const item = this.typeOptions.find((option) => option.value === value);
      return item ? item.label : value;
    },
    async fetchList() {
      this.loading = true;
      try {
        const res = await listResource("service-need-options", { ...this.filters, page: this.page, pageSize: this.pageSize });
        this.rows = res.data && res.data.items ? res.data.items : [];
        this.total = res.data && res.data.total ? res.data.total : 0;
      } finally {
        this.loading = false;
      }
    },
    reset() {
      this.filters = { keyword: "", option_type: "", status: "" };
      this.page = 1;
      this.fetchList();
    },
    openCreate() {
      this.drawerMode = "create";
      this.form = this.emptyForm();
      this.drawerVisible = true;
    },
    openEdit(row) {
      this.drawerMode = "edit";
      this.form = { ...this.emptyForm(), ...row, sort_order: Number(row.sort_order || 0) };
      this.drawerVisible = true;
    },
    save() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return;
        this.saving = true;
        try {
          if (this.form.id) await updateResource("service-need-options", this.form.id, this.form);
          else await createResource("service-need-options", this.form);
          this.$message.success("服务选项已保存");
          this.drawerVisible = false;
          this.fetchList();
        } finally {
          this.saving = false;
        }
      });
    },
    async changeStatus(row, status) {
      await changeResourceStatus("service-need-options", row.id, status);
      this.$message.success(status === "active" ? "选项已启用" : "选项已停用");
      this.fetchList();
    },
    async changeSort(row, sortOrder) {
      await updateResource("service-need-options", row.id, { sort_order: sortOrder });
      this.fetchList();
    }
  }
};
</script>

<style scoped>
.field-help { margin-top: 6px; color: #909399; font-size: 12px; line-height: 1.5; }
</style>
